<section class="cej-testimonials">
  <div
    class="cej-testimonials__container"
    *ngFor="let testimonial of TESTIMONIALS; trackBy: trackByTestimonial; let isOdd = odd"
  >
    <app-cej-v2-testimonial [testimonial]="testimonial" [isOdd]="isOdd"></app-cej-v2-testimonial>
  </div>
</section>
